import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RolParametroAutonomiaComponent } from './rol-parametro-autonomia.component';

const SECURITY_ROUTES: Routes = [
  { path: 'security/rolParametroAutonomia', component: RolParametroAutonomiaComponent }
];

export const ROUTABLE_COMPONENTS = [
];

@NgModule({
  imports: [
    RouterModule.forChild(SECURITY_ROUTES)
  ],
  exports: [
    RouterModule
  ],
  providers: []
})
export class RolParametroAutonomiaRoutingModule { }
